import { useState, useEffect } from 'react';
import { Box, MenuItem } from '@mui/material';
import { CustomSelect, CustomTextField, HorizontalForm } from '../../../common';
import { MESSAGES, FORM_LABELS } from '../constants/generateCouponsConstants';
import {
  getPaymentMethodCode,
  isSpecialPaymentMethod,
  requiresContract,
} from '../utils/generateCouponsUtils';

const TopFormSection = ({
  formData,
  onFormChange,
  branches,
  plans,
  groups,
  paymentMethods,
  onAdecuacionChange,
}) => {
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [filteredPaymentMethods, setFilteredPaymentMethods] = useState([]);

  useEffect(() => {
    if (formData.plan) {
      const newFilteredGroups = groups.filter((group) => group.uuid_plan === formData.plan);
      setFilteredGroups(newFilteredGroups);

      const newFilteredPaymentMethods = paymentMethods.filter(
        (method) => method.uuid_plan === formData.plan
      );
      setFilteredPaymentMethods(newFilteredPaymentMethods);

      if (newFilteredPaymentMethods[0] && !formData.paymentMethod) {
        onFormChange('paymentMethod', newFilteredPaymentMethods[0].uuid);
      }
    } else {
      setFilteredGroups([]);
      setFilteredPaymentMethods([]);
    }
  }, [formData.plan, groups, paymentMethods, onFormChange, formData.paymentMethod]);

  useEffect(() => {
    const selectedPaymentMethod = paymentMethods.find(
      (method) => method.uuid === formData.paymentMethod
    );
    if (selectedPaymentMethod) {
      onAdecuacionChange(selectedPaymentMethod.name);
    }
  }, [formData.paymentMethod, paymentMethods, onAdecuacionChange]);

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    onFormChange(name, value);
  };

  const fieldStyles = {
    width: { xs: '100%', sm: '48%', md: '32%' },
    mb: { xs: 1, md: 0 },
  };

  const paymentMethodCode = getPaymentMethodCode(paymentMethods, formData.paymentMethod);
  const isCurrentMethodSpecial = isSpecialPaymentMethod(paymentMethodCode);
  const contractRequired = requiresContract(paymentMethods, formData.paymentMethod);

  return (
    <HorizontalForm variant="twoRows">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          mb: 2,
          width: '100%',
        }}
      >
        <CustomSelect
          label={FORM_LABELS.BRANCH}
          name="branch"
          value={formData.branch}
          onChange={handleSelectChange}
          sx={fieldStyles}
          size="medium"
        >
          {branches.map((item) => (
            <MenuItem key={item.uuid} value={item.uuid}>
              {item.description}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label={FORM_LABELS.PLAN}
          name="plan"
          value={formData.plan}
          onChange={handleSelectChange}
          sx={fieldStyles}
          size="medium"
        >
          {plans.map((plan) => (
            <MenuItem key={plan.uuid} value={plan.uuid}>
              {plan.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label={FORM_LABELS.GROUP}
          name="group"
          value={formData.group}
          onChange={handleSelectChange}
          sx={fieldStyles}
          size="medium"
        >
          <MenuItem value="all">{FORM_LABELS.ALL}</MenuItem>
          {filteredGroups.map((group) => (
            <MenuItem key={group.uuid} value={group.uuid}>
              {group.name}
            </MenuItem>
          ))}
        </CustomSelect>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          width: '100%',
        }}
      >
        <CustomSelect
          label={FORM_LABELS.PAYMENT_METHOD}
          name="paymentMethod"
          value={formData.paymentMethod}
          onChange={handleSelectChange}
          sx={fieldStyles}
          size="medium"
        >
          {filteredPaymentMethods.map((method) => (
            <MenuItem key={method.uuid} value={method.uuid}>
              {method.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomTextField
          label={FORM_LABELS.CONTRACT}
          name="contract"
          type="number"
          value={formData.contract}
          onChange={handleSelectChange}
          error={contractRequired && formData.contract < 1}
          helperText={contractRequired && formData.contract < 1 ? MESSAGES.CONTRACT_VALIDATION : ''}
          sx={fieldStyles}
          size="medium"
          inputProps={{
            min: 0,
            step: 1,
          }}
        />

        {isCurrentMethodSpecial ? (
          <CustomTextField
            label={FORM_LABELS.DEFERMENT_PERCENTAGE}
            name="defermentPercentage"
            type="number"
            value={formData.defermentPercentage}
            onChange={handleSelectChange}
            sx={fieldStyles}
            size="medium"
            inputProps={{
              min: 0,
              max: 100,
              step: 0.1,
            }}
          />
        ) : (
          <CustomTextField
            label={FORM_LABELS.COEFFICIENT}
            name="coefficient"
            type="number"
            value={formData.coefficient}
            onChange={handleSelectChange}
            sx={fieldStyles}
            size="medium"
            inputProps={{
              min: 0,
              step: 0.01,
            }}
          />
        )}
      </Box>
    </HorizontalForm>
  );
};

export default TopFormSection;
